import { render } from "./EventTablaBoletos.vue?vue&type=template&id=0da730dd&scoped=true"
import script from "./EventTablaBoletos.vue?vue&type=script&lang=js"
export * from "./EventTablaBoletos.vue?vue&type=script&lang=js"

import "./EventTablaBoletos.vue?vue&type=style&index=0&id=0da730dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da730dd"]])

export default __exports__